"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _hexToRgba = _interopRequireDefault(require("hex-to-rgba"));

var _theme = require("../../theme");

var _helpers = require("../../helpers");

var _DefaultButton = _interopRequireDefault(require("./DefaultButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buttonStyleToColor = function buttonStyleToColor(style) {
  if (_theme.statusColors[style]) return (0, _helpers.statusToColor)(style);
  return _theme.colors[style];
};

var StatusButton = (0, _styledComponents.default)(_DefaultButton.default).withConfig({
  displayName: "StatusButton",
  componentId: "sc-1whkcxr-0"
})(["background:", ";border-width:0;&:hover,&:focus{color:", ";background:", " radial-gradient( circle,transparent 1%,", " 1% ) center/15000%;}padding:8px;", " &:active{background-size:100%;transition:background 0s;}"], function (p) {
  return buttonStyleToColor(p.buttonStyle);
}, function (p) {
  return (0, _hexToRgba.default)(buttonStyleToColor(p.buttonStyle), 0.4);
}, function (p) {
  return (0, _hexToRgba.default)(buttonStyleToColor(p.buttonStyle), 0.9);
}, function (p) {
  return (0, _hexToRgba.default)(buttonStyleToColor(p.buttonStyle), 0.9);
}, function (p) {
  return p.hasText && "padding: 8px 20px;";
});
var _default = StatusButton;
exports.default = _default;